{
    "ENV": {
        "TITLE": "EmmenGeeftEnergie | Development",
        "API": "https://dev.api.epf.emmengeeftenergie.nl",
        "WEBSOCKET": "",
        "QR_LOGIN": "false",
        "QR_LOGIN_REFRESH_RATE": "",
        "QR_LOGIN_CHECK_RATE": "",
        "MSAL_CLIENT_ID": "",
        "MSAL_TENANT_ID": "",
        "MSAL_AUTHORITY": "",
        "MSAL_KNOWN_AUTHORITIES": "",
        "HAS_VIDEO": "",
        "MAP_KEY": "",
        "MAP_ID": "",
        "DEBUG": "true",
        "EMAIL_LOGIN": "otp",
        "HIDE_PRIVATE_EMAIL_CHECKBOX": "true"
    }
}